<template>
  <v-dialog v-model="dialogDelete" max-width="600px" persistent>
    <div class="modal-deletar-variacao-container base">
      <div class="modal-deletar-variacao-container1">
        <CloseIcon @action="close" />
      </div>
      <v-container class="pa-0">
        <v-row class="mt-6 mb-3">
          <span class="text-center text-h5 mt-8 mb-2"
            >Tem certeza de que deseja excluir esta variação?
            <strong>{{ deletedItem.descricao }}</strong></span
          >
        </v-row>
        <v-row class="justify-end mt-8 mb-3">
          <v-btn
            height="45"
            class="button btn-border mr-2"
            @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-btn height="45" class="button btn-border" @click="close"
            >Cancelar</v-btn
          >
        </v-row>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalDeletarVariacao",
  components: {
    CloseIcon: () => import("@/components/icons/CloseIcon.vue"),
  },
  props: {
    dialogDelete: {
      type: Boolean,
    },
    deletedItem: {
      type: Object,
    },
    defaultItem: {
      type: Object,
    },
    deletedIndex: {
      type: Number,
    },
  },
  methods: {
    deleteItemConfirm() {
      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.splice(
        this.deletedIndex,
        1
      );
      this.close();
    },
    close() {
      this.$emit("close");
    },
  },
  watch: {
    dialogDelete(val) {
      val || this.close();
    },
  },
};
</script>

<style scoped>
.modal-deletar-variacao-container {
  height: auto;
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 20px;
  flex-direction: column;
  justify-content: center;
  background-color: #eaeaea;
  padding: 1.25rem 1.25rem 0 1.25rem;
}

.modal-deletar-variacao-container1 {
  flex: 0 0 auto;
  width: 100%;
  height: 15%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 1px;
}

.modal-deletar-variacao-icon {
  width: 24px;
  height: 24px;
  margin-top: 3px;
  margin-right: 6px;
}

.modal-deletar-variacao-icon:hover {
  cursor: pointer;
  fill: var(--dl-color-gray-white);
}

.modal-edicao-variacao-button1 {
  color: var(--dl-color-gray-white);
  height: 50px;
  display: flex;
  border-width: 0px;
  border-radius: 10px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
  margin-right: 0.625rem;
}

.modal-edicao-variacao-button2 {
  color: var(--dl-color-gray-white);
  height: 50px;
  display: flex;
  border-width: 0px;
  border-radius: 10px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
}
</style>
